'use client'

import { ReactNode } from 'react'
import { ModalContainer, RegisterModal } from '@/components/atoms/Modal'
import ConfirmDeleteFileModal from '@/components/molecules/ConfirmDeleteFileModal'

// This component registers all modals in the application
export function ModalProvider({ children }: { children: ReactNode }) {
  return (
    <ModalContainer>
      {/* Register all modals here */}
      <RegisterModal
        id='confirm-delete-file'
        component={ConfirmDeleteFileModal}
      />

      {children}
    </ModalContainer>
  )
}
